export enum SelectedPlans {
  Solo = 'Solo',
  Team = 'Team',
  Pro = 'Pro',
  Grow = 'Grow',
}

export const SeatsCountMap = Object.freeze({
  [SelectedPlans.Solo]: 2,
  [SelectedPlans.Team]: 3,
  [SelectedPlans.Pro]: 2,
  [SelectedPlans.Grow]: 10,
});
